import React, { FC, useState } from 'react';
import { useToggle } from 'react-use';
import { Icon } from '@app/components/Icon';
import { Button } from '@chakra-ui/react';
import { IDerivedMintInfo } from '@app/state/mintStore';
import { AddLiquidityModalV3Content } from '@app/screens/positions/components/AddLiquidityModalV3/AddLiquidityModalV3Content';
import { Position } from '@cryptoalgebra/kim-sdk';
import { TransactionResultModal } from '@app/components/TransactionResultModal';
import { useRouter } from 'next/router';

interface Props {
  mintInfo: IDerivedMintInfo;
  fullWidth?: boolean;
  position: Position;
  positionId: number;
}

export const AddLiquidityModalV3: FC<Props> = ({
  mintInfo,
  fullWidth,
  position,
  positionId
}) => {
  const router = useRouter();
  const [feedback, setFeedback] = useState<{
    status: 'success' | 'error';
    title: string;
    message: string;
    txHash?: string;
  } | null>(null);
  const [open, toggleOpen] = useToggle(false);

  return (
    <>
      <Button
        width={fullWidth ? '100%' : ['100%', 'fit-content']}
        leftIcon={
          <Icon name="plusCircle" style={{ width: '18px', height: '18px' }} />
        }
        variant="rowCompact"
        onClick={toggleOpen}
      >
        Add
      </Button>
      {open && (
        <AddLiquidityModalV3Content
          onClose={(txHash?: string) => {
            if (txHash) {
              setFeedback({
                status: 'success',
                title: 'Transaction Confirmed',
                message: 'Your transaction has been successfully completed',
                txHash
              });
            } else {
              toggleOpen(false);
            }
          }}
          isOpen={open}
          mintInfo={mintInfo}
          position={position}
          positionId={positionId}
        />
      )}
      <TransactionResultModal
        isOpen={!!feedback}
        status={feedback?.status}
        title={feedback?.title}
        message={feedback?.message}
        txHash={feedback?.txHash}
        onClose={() => {
          setFeedback(null);
          router.reload();
        }}
      />
    </>
  );
};
